import React, { useState, useEffect } from "react";
import { FaPlay } from "react-icons/fa";
import youtubeThumbnail from "youtube-thumbnail";
import VideoModal from "../videoModal";
import "./styles.css";
import AOS from "aos";
import "aos/dist/aos.css";

const GridComponent = ({ data }) => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoId, setVideoId] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 1000, // set the animation duration (in milliseconds)
    });
  }, []);


  const handleClose = () => setShowVideoModal(false);
  const handleShow = (id) => {
    setShowVideoModal(true);
    setVideoId(id);
  };

  return (
    <div className="movingArts">
      <div className="gridContainer">
        {data &&
          data.map((data, i) => {
            const thumbnail = youtubeThumbnail(data.video_url).high.url;

            return (
              <div
                key={i}
                className="gridItem"
                data-aos="zoom-in"
                data-aos-duration="1500"
              >
                {/* <span className="lvStory">Love Story</span> */}
                <div className="imageContainer">
                  <img src={thumbnail} alt="" />
                  <FaPlay
                    size={30}
                    className="playButton"
                    onClick={() => handleShow(data.video_url)}
                  />
                </div>
                <span className="storyTitle">{data.title}</span>
                <p className="storydiscription">{data.description}</p>
              </div>
            );
          })}
      </div>
      <VideoModal
        id={videoId}
        show={showVideoModal}
        handleClose={handleClose}
        setShow={setShowVideoModal}
      />
    </div>
  );
};

export default GridComponent;
